/* import __COLOCATED_TEMPLATE__ from './editor.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file: 🚀 */
/* eslint-disable @intercom/intercom/require-snake-case-analytics */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-classic-components */
/* eslint-disable @intercom/intercom/require-empty-tagname */
import Component from '@ember/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default Component.extend({
  tagName: '',
  intercomEventService: service(),
  firstEdit: true,

  updateBuilderJson: action(function (newJson) {
    if (this.firstEdit) {
      this.set('firstEdit', false);
      this.intercomEventService.trackAnalyticsEvent({
        action: 'edited',
        object: 'canvas-kit-builder',
      });
    }
    this.set('componentsJson', newJson);
  }),
});
